import { withOptionsEndpoint } from "@dgs/core";
import { ApprovingUserOptionResource } from "../types/organizationalUnitUser";

const baseKey = ["organizational-unit-users"];

export const organizationalUnitUserService = {
	baseKey,
	...withOptionsEndpoint<ApprovingUserOptionResource>(baseKey),
};
